import { jsx as o } from "react/jsx-runtime";
import { styled as r } from "@mui/joy";
import e from "@mui/joy/Stack";
import t from "@mui/joy/Typography";
const m = r(e)(({ theme: o2 }) => ({ flex: 1, paddingLeft: o2.spacing(1.25) })), i = ({ children: r2, sx: e2 }) => o(t, { level: "body-xs", textColor: "neutral.700", sx: { b: { fontSize: "1.1em" }, ...e2 }, children: r2 });
export {
  m as FooterColumn,
  i as FooterText
};
//# sourceMappingURL=TableFooter.js.map
